// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Label preview modal — components/LabelPrintModal.js.
   Reuses .wop-btn from work-orders-print.css (loaded by every print page). */

.lpm-backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  background: rgba(25, 23, 20, 0.45);
  -webkit-backdrop-filter: blur(3px);
          backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-family: "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.lpm {
  width: min(100%, 1180px);
  max-height: calc(100vh - 48px);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 24px 60px rgba(25, 23, 20, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.lpm.is-narrow {
  width: min(100%, 460px);
}

.lpm-head {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 18px 22px 14px;
  border-bottom: 1px solid #e2dcd0;
}
.lpm-head-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.lpm-kicker {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--rf-brand);
}
.lpm-title {
  margin: 0;
  font: 400 24px/1.1 "Instrument Serif", Georgia, "Times New Roman", serif;
}
.lpm-sub {
  font-size: 12.5px;
  color: #8b8477;
}
.lpm-x {
  margin-left: auto;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #e2dcd0;
  background: #fff;
  color: #6f6a60;
  font-size: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}
.lpm-x:hover {
  background: #fdfbf6;
  color: #191714;
}

.lpm-body {
  display: grid;
  grid-template-columns: 300px minmax(0, 1fr);
  min-height: 0;
  flex-grow: 1;
  overflow: hidden;
}
.lpm-edit {
  padding: 18px 20px;
  border-right: 1px solid #e2dcd0;
  background: #fbfaf7;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: auto;
}
.lpm-edit-h {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8b8477;
}
.lpm-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
}
.lpm-field > span {
  font-size: 11.5px;
  font-weight: 600;
  color: #6f6a60;
}
.lpm-field input,
.lpm-field textarea {
  font: 500 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  padding: 8px 10px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  outline: none;
  resize: vertical;
}
.lpm-field input:focus,
.lpm-field textarea:focus {
  border-color: var(--rf-brand-lite);
  box-shadow: 0 0 0 3px var(--rf-brand-tint);
}
.lpm-edit .wop-btn {
  justify-content: center;
  margin-top: 4px;
}
.lpm-edit-hint {
  font-size: 11.5px;
  color: #a29b8d;
  line-height: 1.4;
}

.lpm-labels {
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: #f4f1ea;
}
.lpm-labels-bar {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 20px;
  border-bottom: 1px solid #e2dcd0;
  background: #fff;
}
.lpm-all {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.lpm-count {
  margin-left: auto;
  font-size: 12px;
  color: #8b8477;
}
.lpm-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  /* Cards clip (overflow: hidden), so auto rows would shrink to share the
     scroll area's height once there are 3+ rows, cropping each label.
     Size rows to their content and let the grid scroll instead. */
  grid-auto-rows: max-content;
  gap: 14px;
  padding: 18px 20px;
  overflow: auto;
}
.lpm-card {
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 10px;
  overflow: hidden;
  transition: border-color 150ms, box-shadow 150ms;
}
.lpm-card.is-on {
  border-color: var(--rf-brand-lite);
  box-shadow: 0 0 0 3px var(--rf-brand-tint);
}
.lpm-card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  margin: 0;
  cursor: pointer;
  border-bottom: 1px solid #f0ece3;
}
.lpm-card-head input,
.lpm-all input {
  width: 16px;
  height: 16px;
  accent-color: var(--rf-brand);
  margin: 0;
}
.lpm-card-title {
  font-size: 13px;
  font-weight: 700;
}
.lpm-card-cap {
  margin-left: auto;
  font-size: 11.5px;
  color: #8b8477;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 55%;
}
.lpm-card-body {
  aspect-ratio: 304 / 192;
  background: #eae6dd;
  position: relative;
}
.lpm-pdf {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
  background: #fff;
}
.lpm-card-state {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #8b8477;
}
.lpm-card-state.is-error {
  color: #a8483e;
}
.lpm-card-state svg {
  font-size: 22px;
}
.lpm-skel {
  width: 60%;
  height: 10px;
  border-radius: 5px;
  background: linear-gradient(90deg, #ddd7cb 25%, #f4f1ea 50%, #ddd7cb 75%);
  background-size: 200% 100%;
  animation: lpm-shimmer 1.3s infinite;
}
@keyframes lpm-shimmer {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}

.lpm-foot {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 20px;
  border-top: 1px solid #e2dcd0;
  background: #fff;
  flex-wrap: wrap;
}
.lpm-notice {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 8px;
}
.lpm-notice svg {
  font-size: 16px;
}
.lpm-notice.is-ok {
  color: #4d7a52;
  background: #eaf1e9;
}
.lpm-notice.is-err {
  color: #a8483e;
  background: #f7ebe9;
}
.lpm-foot-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
}

.lpm-picker {
  position: relative;
}
.lpm-picker-btn {
  height: 38px;
  padding: 0 10px 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: inherit;
  cursor: pointer;
  min-width: 260px;
  text-align: left;
}
.lpm-picker-btn:hover:not(:disabled) {
  border-color: #d8cfb8;
}
.lpm-picker-btn:disabled {
  cursor: default;
  color: #a29b8d;
}
.lpm-picker-k {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--rf-brand);
  padding-right: 10px;
  border-right: 1px solid #e2dcd0;
}
.lpm-picker-v {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #191714;
  min-width: 0;
  flex-grow: 1;
}
.lpm-picker-v > svg {
  color: #8b8477;
}
.lpm-picker-pc {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 500;
  color: #8b8477;
  margin-left: 4px;
}
.lpm-picker-caret {
  font-size: 20px;
  color: #6f6a60;
}
.lpm-picker-list {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 0;
  right: 0;
  margin: 0;
  padding: 6px;
  list-style: none;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(25, 23, 20, 0.18);
  max-height: 240px;
  overflow: auto;
  z-index: 2;
}
.lpm-picker-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 7px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}
.lpm-picker-list li > svg {
  color: var(--rf-brand-lite);
  font-size: 18px;
}
.lpm-picker-list li:hover {
  background: #fdfbf6;
}
.lpm-picker-list li.is-on {
  background: var(--rf-brand-tint);
}
.lpm-picker-name {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.lpm-empty {
  padding: 34px 28px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  color: #4a453c;
  font-size: 13px;
  line-height: 1.5;
}
.lpm-empty > svg {
  font-size: 34px;
  color: #b0872f;
}
.lpm-empty .wop-btn {
  margin-top: 10px;
}

@media (max-width: 900px) {
  .lpm-body {
    grid-template-columns: 1fr;
    overflow: auto;
  }
  .lpm-edit {
    border-right: none;
    border-bottom: 1px solid #e2dcd0;
  }
}
@media print {
  .lpm-backdrop {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/label-print-modal.css"],"names":[],"mappings":"AAAA;6EAC6E;;AAE7E;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4DAA4D;EAC5D,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,wEAAwE;AAC1E;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,8DAA8D;EAC9D,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;;EAEE,kCAAkC;EAClC,0CAA0C;AAC5C;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D;;kEAEgE;EAChE,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Label preview modal — components/LabelPrintModal.js.\n   Reuses .wop-btn from work-orders-print.css (loaded by every print page). */\n\n.lpm-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n  background: rgba(25, 23, 20, 0.45);\n  backdrop-filter: blur(3px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  font-family: \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.lpm {\n  width: min(100%, 1180px);\n  max-height: calc(100vh - 48px);\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 24px 60px rgba(25, 23, 20, 0.3);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.lpm.is-narrow {\n  width: min(100%, 460px);\n}\n\n.lpm-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 18px 22px 14px;\n  border-bottom: 1px solid #e2dcd0;\n}\n.lpm-head-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n.lpm-kicker {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--rf-brand);\n}\n.lpm-title {\n  margin: 0;\n  font: 400 24px/1.1 \"Instrument Serif\", Georgia, \"Times New Roman\", serif;\n}\n.lpm-sub {\n  font-size: 12.5px;\n  color: #8b8477;\n}\n.lpm-x {\n  margin-left: auto;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 1px solid #e2dcd0;\n  background: #fff;\n  color: #6f6a60;\n  font-size: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.lpm-x:hover {\n  background: #fdfbf6;\n  color: #191714;\n}\n\n.lpm-body {\n  display: grid;\n  grid-template-columns: 300px minmax(0, 1fr);\n  min-height: 0;\n  flex-grow: 1;\n  overflow: hidden;\n}\n.lpm-edit {\n  padding: 18px 20px;\n  border-right: 1px solid #e2dcd0;\n  background: #fbfaf7;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  overflow: auto;\n}\n.lpm-edit-h {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #8b8477;\n}\n.lpm-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0;\n}\n.lpm-field > span {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #6f6a60;\n}\n.lpm-field input,\n.lpm-field textarea {\n  font: 500 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  padding: 8px 10px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  outline: none;\n  resize: vertical;\n}\n.lpm-field input:focus,\n.lpm-field textarea:focus {\n  border-color: var(--rf-brand-lite);\n  box-shadow: 0 0 0 3px var(--rf-brand-tint);\n}\n.lpm-edit .wop-btn {\n  justify-content: center;\n  margin-top: 4px;\n}\n.lpm-edit-hint {\n  font-size: 11.5px;\n  color: #a29b8d;\n  line-height: 1.4;\n}\n\n.lpm-labels {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  background: #f4f1ea;\n}\n.lpm-labels-bar {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 20px;\n  border-bottom: 1px solid #e2dcd0;\n  background: #fff;\n}\n.lpm-all {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.lpm-count {\n  margin-left: auto;\n  font-size: 12px;\n  color: #8b8477;\n}\n.lpm-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  /* Cards clip (overflow: hidden), so auto rows would shrink to share the\n     scroll area's height once there are 3+ rows, cropping each label.\n     Size rows to their content and let the grid scroll instead. */\n  grid-auto-rows: max-content;\n  gap: 14px;\n  padding: 18px 20px;\n  overflow: auto;\n}\n.lpm-card {\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 10px;\n  overflow: hidden;\n  transition: border-color 150ms, box-shadow 150ms;\n}\n.lpm-card.is-on {\n  border-color: var(--rf-brand-lite);\n  box-shadow: 0 0 0 3px var(--rf-brand-tint);\n}\n.lpm-card-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  margin: 0;\n  cursor: pointer;\n  border-bottom: 1px solid #f0ece3;\n}\n.lpm-card-head input,\n.lpm-all input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--rf-brand);\n  margin: 0;\n}\n.lpm-card-title {\n  font-size: 13px;\n  font-weight: 700;\n}\n.lpm-card-cap {\n  margin-left: auto;\n  font-size: 11.5px;\n  color: #8b8477;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 55%;\n}\n.lpm-card-body {\n  aspect-ratio: 304 / 192;\n  background: #eae6dd;\n  position: relative;\n}\n.lpm-pdf {\n  width: 100%;\n  height: 100%;\n  border: none;\n  display: block;\n  background: #fff;\n}\n.lpm-card-state {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #8b8477;\n}\n.lpm-card-state.is-error {\n  color: #a8483e;\n}\n.lpm-card-state svg {\n  font-size: 22px;\n}\n.lpm-skel {\n  width: 60%;\n  height: 10px;\n  border-radius: 5px;\n  background: linear-gradient(90deg, #ddd7cb 25%, #f4f1ea 50%, #ddd7cb 75%);\n  background-size: 200% 100%;\n  animation: lpm-shimmer 1.3s infinite;\n}\n@keyframes lpm-shimmer {\n  from {\n    background-position: 200% 0;\n  }\n  to {\n    background-position: -200% 0;\n  }\n}\n\n.lpm-foot {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 12px 20px;\n  border-top: 1px solid #e2dcd0;\n  background: #fff;\n  flex-wrap: wrap;\n}\n.lpm-notice {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12.5px;\n  font-weight: 600;\n  padding: 6px 10px;\n  border-radius: 8px;\n}\n.lpm-notice svg {\n  font-size: 16px;\n}\n.lpm-notice.is-ok {\n  color: #4d7a52;\n  background: #eaf1e9;\n}\n.lpm-notice.is-err {\n  color: #a8483e;\n  background: #f7ebe9;\n}\n.lpm-foot-right {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.lpm-picker {\n  position: relative;\n}\n.lpm-picker-btn {\n  height: 38px;\n  padding: 0 10px 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-family: inherit;\n  cursor: pointer;\n  min-width: 260px;\n  text-align: left;\n}\n.lpm-picker-btn:hover:not(:disabled) {\n  border-color: #d8cfb8;\n}\n.lpm-picker-btn:disabled {\n  cursor: default;\n  color: #a29b8d;\n}\n.lpm-picker-k {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--rf-brand);\n  padding-right: 10px;\n  border-right: 1px solid #e2dcd0;\n}\n.lpm-picker-v {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n  min-width: 0;\n  flex-grow: 1;\n}\n.lpm-picker-v > svg {\n  color: #8b8477;\n}\n.lpm-picker-pc {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #8b8477;\n  margin-left: 4px;\n}\n.lpm-picker-caret {\n  font-size: 20px;\n  color: #6f6a60;\n}\n.lpm-picker-list {\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  margin: 0;\n  padding: 6px;\n  list-style: none;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 10px;\n  box-shadow: 0 10px 30px rgba(25, 23, 20, 0.18);\n  max-height: 240px;\n  overflow: auto;\n  z-index: 2;\n}\n.lpm-picker-list li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 7px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n}\n.lpm-picker-list li > svg {\n  color: var(--rf-brand-lite);\n  font-size: 18px;\n}\n.lpm-picker-list li:hover {\n  background: #fdfbf6;\n}\n.lpm-picker-list li.is-on {\n  background: var(--rf-brand-tint);\n}\n.lpm-picker-name {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.lpm-empty {\n  padding: 34px 28px 28px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 8px;\n  color: #4a453c;\n  font-size: 13px;\n  line-height: 1.5;\n}\n.lpm-empty > svg {\n  font-size: 34px;\n  color: #b0872f;\n}\n.lpm-empty .wop-btn {\n  margin-top: 10px;\n}\n\n@media (max-width: 900px) {\n  .lpm-body {\n    grid-template-columns: 1fr;\n    overflow: auto;\n  }\n  .lpm-edit {\n    border-right: none;\n    border-bottom: 1px solid #e2dcd0;\n  }\n}\n@media print {\n  .lpm-backdrop {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
